import { render } from "./AboutMap.vue?vue&type=template&id=52edc908&scoped=true"
import script from "./AboutMap.vue?vue&type=script&lang=js"
export * from "./AboutMap.vue?vue&type=script&lang=js"

import "./AboutMap.vue?vue&type=style&index=0&id=52edc908&lang=scss&scoped=true"

import exportComponent from "/home/ajdin/forspace-web/forspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52edc908"]])

export default __exports__